import React from 'react'
import { Controller } from 'react-hook-form'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import { isPrivatePhoneValid } from '../../../utils/validators'
import UserFormField from '../UserFormField'
import { useFormContextUser } from '../utils/_utils'
import { useUserFormContext } from '../utils/userFormContext'
import { getTooltipTitle, HIDDEN_PHONE_VALUE, missingPrivatePhoneErrorMessage } from './_utils'
import Reminder from './Reminder/Reminder'
import { NO_PHONE_VALUE } from '../../Common/form/_utils/utils'
import { FormFieldActionButton } from '../../Common/form/formField/_props'

const PrivatePhone: React.FC = () => {
    const { control, watch, setValue } = useFormContextUser()
    const { state, update } = useUserFormContext()

    const watched = {
        defaultPrivatePhone: watch('defaultPrivatePhone'),
        smsNotification: watch('notification.sms'),
        hasChangedPrivatePhone: watch('hasChangedPrivatePhone'),
        privatePhone: watch('privatePhone'),
        selfMode: watch('selfMode'),
    }

    const isDisabled = watched.selfMode || state.isEditionMode

    const getActionButton = (): FormFieldActionButton | undefined => {
        if (watched.selfMode) {
            return {
                label: 'Modifier',
                icon: <EditIcon />,
                action: () =>
                    update({
                        redirectKey: 'phone',
                    }),
            }
        }
        if (state.isEditionMode && watched.privatePhone) {
            return {
                label: 'Réinitialiser',
                icon: <DeleteIcon />,
                action: () => {
                    setValue('privatePhone', '')
                },
            }
        }
        return undefined
    }

    return (
        <Controller
            control={control}
            name="privatePhone"
            rules={{
                required: watched.smsNotification ? missingPrivatePhoneErrorMessage : false,
                validate: (val) => isPrivatePhoneValid(val, watched.smsNotification),
            }}
            render={({ field, fieldState: { error } }) => (
                <>
                    <UserFormField
                        variant="input"
                        label="Numéro de téléphone mobile (utilisé pour la connexion sécurisée)"
                        required={watched.smsNotification}
                        {...field}
                        status={{
                            error,
                            valid: (field.value?.trim().length ?? 0) > 0,
                        }}
                        value={!watched.selfMode && field?.value ? HIDDEN_PHONE_VALUE : field?.value}
                        onChange={(e) => {
                            const privatePhoneHasChanged = e.target.value !== watched.defaultPrivatePhone
                            setValue('hasChangedPrivatePhone', privatePhoneHasChanged)
                            field.onChange(e)
                        }}
                        placeholder="00 00 00 00 00"
                        dataCyScope="UserField"
                        disabled={isDisabled}
                        noValueText={NO_PHONE_VALUE}
                        tooltipTitle={getTooltipTitle(Boolean(watched.selfMode), state.isEditionMode, 'phone')}
                        actionButton={getActionButton()}
                    />
                    {state.isEditionMode && watched.hasChangedPrivatePhone && watched.privatePhone && <Reminder />}
                </>
            )}
        />
    )
}

export default PrivatePhone
